import { render } from "./ModalPn.vue?vue&type=template&id=d2266b9a"
import script from "./ModalPn.vue?vue&type=script&lang=js"
export * from "./ModalPn.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__